import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";

type Command = Database['public']['Tables']['documents']['Insert'][];

async function postDocuments(command: Command) {
  const { error } = await apiClient
    .from('documents')
    .insert(command);

  if (error) {
    throw error
  }
}

export function usePostDocuments() {
  return useMutation({
    mutationFn: async (variables: { command: Command }) => postDocuments(variables.command)
  })
}
